export enum Subtest {
    SSAISRTest1 = 1,
    SSAISRTest2 = 2,
    SSAISRTest3 = 3,
    SSAISRTest8 = 4,
}